import Heading from "../ui/Heading.jsx";
import SignupForm from "../features/authentication/SignupForm.jsx";
import styled from "styled-components";

const SignupLayout = styled.main`
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: start;
    padding-top: 80px;
    margin-top: 200px;

    & > .card {
        width: 100%;
        max-width: 28rem;
        background: white;
        padding: 1.5rem;
        border-radius: 1rem;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    }
`;

function SignupPage() {
    return (
        <SignupLayout>
            <div>
                <Heading as={"h3"} className="text-center font-bold mb-4">
                    Create a new user
                </Heading>
                <SignupForm />
            </div>
        </SignupLayout>
    );
}

export default SignupPage;